import './Home.css'

import a from "/Users/nikkylu/lumed/src/pages/components/wound/a.jpg";
import b from "/Users/nikkylu/lumed/src/pages/components/wound/b.jpg";
import c from "/Users/nikkylu/lumed/src/pages/components/wound/c.jpg";
import d from "/Users/nikkylu/lumed/src/pages/components/wound/d.jpg";
import e from "/Users/nikkylu/lumed/src/pages/components/wound/e.jpg";
import f from "/Users/nikkylu/lumed/src/pages/components/wound/f.jpg";
import g from "/Users/nikkylu/lumed/src/pages/components/wound/g.jpg";
import h from "/Users/nikkylu/lumed/src/pages/components/wound/h.jpg";
import i from "/Users/nikkylu/lumed/src/pages/components/wound/i.png";
import j from "/Users/nikkylu/lumed/src/pages/components/wound/j.jpg";
import k from "/Users/nikkylu/lumed/src/pages/components/wound/k.jpg";
import l from "/Users/nikkylu/lumed/src/pages/components/wound/l.jpg";
import m from "/Users/nikkylu/lumed/src/pages/components/wound/m.jpg";
import n from "/Users/nikkylu/lumed/src/pages/components/wound/n.jpg";
import o from "/Users/nikkylu/lumed/src/pages/components/wound/o.jpg";
import p from "/Users/nikkylu/lumed/src/pages/components/wound/p.jpg";
import q from "/Users/nikkylu/lumed/src/pages/components/wound/q.jpg";
import r from "/Users/nikkylu/lumed/src/pages/components/wound/r.jpg";



const Wound = () => {


  return (
    
    <div className="Home">
        <div>Various Wound Dressings</div>
        <div className="Home-con">
    <img src={a} className="Home-sp"/>
    <div className="Home-s">
        <div>Transparent Film Dressing, various sizes</div>
        <div>Transparent type, PU film, coated with acrylic acid adhesive plaster. Green-squares shape, or other shapes, various sizes. Good for protecting the skin which is easy for bruising or external infection, and fixation on catheter or on venous cannula.</div>
    </div>
</div>

<div className="Home-con">
    <img src={b} className="Home-sp"/>
    <div className="Home-s">
        <div>Paper frame type, good for fixation on catheter or on venous cannula.</div>
    </div>
</div>

<div className="Home-con">
    <img src={c} className="Home-sp"/>
    <img src={d} className="Home-sp"/>
    <div className="Home-s">
        <div>High-permeable grid-coating type, good for use of the peripheral venous catheter, CVC subclavian vein catheter, epidural catheter or other catheter fixation.</div>
    </div>
</div>

<div className="Home-con">
    <img src={e} className="Home-sp"/>
    <div className="Home-s">
        <div>Transparent Island Dressing, various sizes</div>
        <div>PU film, coated with acrylic acid adhesive, with a pure cotton fiber absorbent pad core in the middle. Good for use of dressing and fixation of various wounds (sterile care for post-operative wound, wounds of acute and chronic injury, wounds of small cutting injury and abrasions, etc.).</div>
    </div>
</div>

<div className="Home-con">
    <img src={f} className="Home-sp"/>
    <div className="Home-s">
        <div>PU Film Dressing Roll, various sizes</div>
        <div>Transparent PU film, coated with pressure-sensitive adhesive plaster, such as medical acrylic pressure-sensitive adhesive or medical heat-sensitive adhesive. Good for use of wound dressing, patch, infant navel plaster, indwelling needle plaster, and catheter fixing plasters.</div>
    </div>
</div>

       <div className="Home-con">
    <img src={g} className="Home-sp"/>
    <div className="Home-s">
        <div>Non-Woven Dressing Roll, various sizes</div>
        <div>Non-woven fabric, coated with medical pressure sensitive adhesive, released paper has straight/S curve cutting. Good for use of band-aid plaster, wound dressing, patch, infant navel plaster, indwelling needle plaster, and catheter fixing plasters.</div>
    </div>
</div>

<div className="Home-con">
    <img src={h} className="Home-sp"/>
    <div className="Home-s">
        <div>Silicone Adhesive Tape, various sizes</div>
        <div>Transparent, PU tape coated with silicone gel, rolled on a plastic spool. Size: 1.9cm/2.5cm/5cm x 1.5m/5m. Good for use on patients where the skin condition is poor, sensitive, fragile, or need to replace the dressing in the same skin place. Applicable to various in-dwelling catheters, electrodes, or other external fixation. Cannot be used with oxidant, such as hypochlorite solution and hydrogen peroxide solution.</div>
    </div>
</div>

<div className="Home-con">
    <img src={i} className="Home-sp"/>
    <img src={j} className="Home-sp"/>
    <div className="Home-s">
        <div>Catheter Stabilization Dressing, various sizes</div>
        <div>Non-woven fabric, coated with acrylic acid adhesive, PE foam, released paper. Good for use to fix drainage tubes of various locations and other CVC, PICC type catheters. Attention: Dressings stick parts should be flat with no scar folds, local skin should be cleaned before using dressing.</div>
    </div>
</div>

<div className="Home-con">
    <img src={k} className="Home-sp"/>
    <div className="Home-s">
        <div>Non-Woven Fixation Dressing for I.V. Cannula, sizes: 6cmx8cm</div>
        <div>Non-woven fabric, coated with special acrylic acid adhesive. Good for use to fix I.V. Cannula or other tubing, cover and protect abrasions, cuts, minor burns, blisters and post-surgical incisions.</div>
    </div>
</div>

<div className="Home-con">
    <img src={l} className="Home-sp"/>
    <div className="Home-s">
        <div>Transparent Film Fixation Dressing for I.V. Catheter, size: 6cmx8cm</div>
        <div>Transparent, PU film, coated with special acrylic acid adhesive. Good for use to cover and protect abrasions, cuts, minor burns, blisters, secure I.V. Catheters or other tubing and post-surgical incisions.</div>
    </div>
</div>

<div className="Home-con">
    <img src={m} className="Home-sp"/>
    <div className="Home-s">
        <div>First Aid Wound Strip, various sizes</div>
        <div>PE/cotton/elastic/non-woven fabric, with an absorbent pad in the middle. Good for use in the emergency medical supplies in hospitals, clinics, and households.</div>
    </div>
</div>

<div className="Home-con">
    <img src={n} className="Home-sp"/>
    <img src={o} className="Home-sp"/>
    <div className="Home-s">
        <div>Silicone Border/Non-Border Foam Dressing, various sizes</div>
        <div>PU waterproof film + super absorbent layer + super absorbent foam layer +mesh silicone adhesive layer + silicone release paper. Good for chronic and acute wounds with moderate to high exuding, and for the prevention and treatment of pressure ulcers.</div>
    </div>
</div>

<div className="Home-con">
    <img src={p} className="Home-sp"/>
    <div className="Home-s">
        <div>PU Foam Dressing, various sizes</div>
        <div>With/without PU film backing, and absorbent PU foam. Good for absorbing exudate from the wound surface, maintaining a moist healing environment, and accelerating wound healing.</div>
    </div>
</div>

<div className="Home-con">
    <img src={q} className="Home-sp"/>
    <img src={r} className="Home-sp"/>
    <div className="Home-s">
        <div>Wound Closure Strips, various sizes</div>
        <div>Consisting of adhesive tape, a pair of polypropylene hasp and ribbons, or non-woven fabric. Good for a non-invasive closure of a wound and to encourage a tight closure for early and successful healing.</div>
    </div>
</div>

    </div>
  )
}

export default Wound;